import { theme } from '../../theme/theme';

export type ITheme = typeof theme;

export enum Theme {
  Light = 'light',
  Dark = 'dark',
  // Cyan = 'cyan',
  // Book = 'book',
  // Magenta = 'magenta',
}
